module.exports = __webpack_public_path__ + "img/level-down.71c5c977.svg";